import { getIntegerAsString, getDateAsMoment } from 'data/booking/selectors/form';

function getDefaultValues() {
    return {
        date: null,
        people: null,
        journey: {
            departure: null,
            arrival: null,
            time: null,
            price: null
        }
    };
}

function getEditValues(state) {
    const { entities, editingItem } = state.booking;
    const item = entities.items[editingItem];

    return {
        date: getDateAsMoment(item.date),
        people: getIntegerAsString(item.people),
        journey: {
            departure: item.from,
            arrival: item.to,
            time: item.hour
        }
    };
}

function equals(itemA, itemB){
    return getDateAsMoment(itemA.date).format() == getDateAsMoment(itemB.date).format()
        && itemA.people == itemB.people
        && itemA.hour == itemB.hour
        && itemA.from && itemB.from && itemA.from.id == itemB.from.id
        && itemA.to && itemB.to && itemA.to.id == itemB.to.id
}

export {
    getDefaultValues,
    getEditValues,
    equals
};
